import { render } from "./PagerView.vue?vue&type=template&id=cc15b56e"
import script from "./PagerView.vue?vue&type=script&lang=js"
export * from "./PagerView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Work\\house_keeping\\website-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__